import * as CONST from "./actionTypes";

export const getSettings = (payload) => ({
  type: CONST.GET_SETTINGS,
  payload: payload,
});

export const getSettingsSuccess = (data) => ({
  type: CONST.GET_SETTINGS_SUCCESS,
  payload: data,
});

export const getSettingsFail = (error) => ({
  type: CONST.GET_SETTINGS_FAIL,
  payload: error,
});


export const getFaqs = (payload) => ({
  type: CONST.GET_FAQS,
  payload: payload,
});

export const getFaqsSuccess = (data) => ({
  type: CONST.GET_FAQS_SUCCESS,
  payload: data,
});

export const getFaqsFail = (error) => ({
  type: CONST.GET_FAQS_FAIL,
  payload: error,
});




